import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "interest-male-fashion--sprite",
  "use": "interest-male-fashion--sprite-usage",
  "viewBox": "0 0 6 16",
  "content": "<symbol viewBox=\"0 0 6 16\" id=\"interest-male-fashion--sprite\">\n<path d=\"M1.4001 1.60113C1.4001 0.716194 2.1163 0 3.00123 0C3.88616 0 4.60235 0.716194 4.60235 1.60113C4.60235 2.48606 3.88616 3.20225 3.00123 3.20225C2.1163 3.1985 1.4001 2.48231 1.4001 1.60113ZM4.20113 4.00094H1.80132C0.920139 4.00094 0.200195 4.72088 0.200195 5.59831V9.99672H1.4001V15.9963H4.5986V9.99672H5.79851V5.59831C5.79851 4.72088 5.07856 4.00094 4.20113 4.00094Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol